import React from "react";

const ConnectionContext = React.createContext({});
export const ConnectionProvider = ConnectionContext.Provider;

export default ConnectionContext;
